export class TaskModel {
    id: number
    name: string
    description: string
    progress: number
    application: number
    link_feedback: number
    created_by: number
    modified_by: number
    assigned_to: [number]
    assigned_to_name:[string]
    status: number
    priority: number
    created_at: string
    comment_count: number
    due_date:string
    attachment:Attchment[]
    attachments:any[]
    task_attachment:any[]
    template_data: TaskTemplateData
    showPriority:boolean
    showAssign:boolean
    showTime:boolean
    showUpcoming:boolean
    showProgress:boolean
    is_upcoming_release:boolean
    feedback_name:string
    task_status_details: TaskStatusDetail
    task_status: number
    task_type: string[]
}

export class TaskHistoryModel {
    by:string
    date:string
    id:number
    text:string
}

export class TaskStatusDetail {
    application: []
    application_list: []
    hexcolor: string
    id: number
    name: string
}

export class TaskTemplateData {
    status_name: string
    status_color: string
    priority_name: string
    priority_color: string
    progress_color: string
    application_name: string
    assigned_to_name: any
    created_by_name: string
    modified_by_name: string
    due_date:string
}

export class TaskResponseModel {
    count: number
    next: string
    previous: string
    results: [TaskModel]

}


export class TaskFilterModel {
    title:string
    name:string;
    status!:any
    priority:number
    application!:any
    create_by:number
    assigned_to!:any
    task_type!:any
    assigned_to_order:boolean
    priority_order:boolean
    date_order:boolean
    descend:boolean
    ascend:boolean
    due_date:string
    filter_due_date__lte:string
    filter_due_date__gte:string
}


export class TaskComment {
    id: number
    comment: string
    task: number
    is_feedback:boolean
    created_by: number
    created_at: string
    modified_by: number
    template_data: TaskCommentTemplateData
    attachments:any[]
    comment_attachment:any[]
}

export class TaskCommentTemplateData {
    created_by_name: string
}

export class TaskCommentsResponseModel {
    count: number
    next: string
    previous: string
    results: [TaskComment]

}

export class Attchment {
    id: number;
    path:string;
    url:string
}
